import Home from "components/layouts/Home.jsx";
import { withRouter } from "react-router-dom";

const IndexRoutes = [{ path: "/", component: Home }];

export default withRouter(IndexRoutes);
